import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.css',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class ButtonComponent {
  @Input() variant: 'filled' | 'outlined' | 'text' | 'icon' = 'filled';
  @Input() color: 'primary' | 'accent' | 'warn' | 'danger' = 'primary';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  /** Associates a `type="submit"` button with a `<form>` it isn't nested inside --
   *  the native `form` attribute, forwarded to the inner `<button>` since Angular
   *  doesn't propagate unbound host attributes into a component's own template. */
  @Input() form?: string;
}
